import { QuantityInput } from "~/common/components/QuantityInput/QuantityInput";
import { Alert, MenuItem, Stack, TextField, Typography } from "~/common/mui";

interface ConfiguredProductCommerceControlsProps {
  priceText: string;
  quantity: number;
  priceReference: string;
  priceReferences: readonly { label: string; value: string }[];
  priceReferenceEditable: boolean;
  error?: string;
  onQuantityChange: (quantity: number) => void;
  onPriceReferenceChange: (priceReference: string) => void;
}

export const ConfiguredProductCommerceControls = ({
  priceText,
  quantity,
  priceReference,
  priceReferences,
  priceReferenceEditable,
  error,
  onQuantityChange,
  onPriceReferenceChange,
}: ConfiguredProductCommerceControlsProps) => (
  <Stack gap={2}>
    <Typography variant="titleLarge">{priceText}</Typography>
    <TextField
      id="configured-product-price-reference"
      select
      fullWidth
      disabled={!priceReferenceEditable}
      value={priceReference}
      label="Price reference"
      onChange={(event) => onPriceReferenceChange(event.target.value)}
      slotProps={{
        inputLabel: { shrink: true },
        select: { displayEmpty: true },
      }}
    >
      {priceReferences.map((reference) => (
        <MenuItem key={reference.value} value={reference.value}>
          {reference.label}
        </MenuItem>
      ))}
    </TextField>
    <QuantityInput value={quantity} min={1} step={1} persistentMinValue fullWidth onValueChange={onQuantityChange} />
    {error && <Alert severity="error">{error}</Alert>}
  </Stack>
);
